import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface WarningIconProps {
  className?: string;
}

function WarningIcon({className}: WarningIconProps): JSX.Element {
  return <BenchlingIcon icon="warning" className={classNames('u-dark-warning-color', className)} />;
}

export default WarningIcon;
